import { useCallback, useEffect, useMemo, useState } from "react";
import styled from "styled-components";
import Slider from "react-slick";
import { BREAK_POINT } from "../constants";

const Synopsys = () => {
  const [firstClientX, setFirstClientX] = useState(0);
  const [firstClientY, setFirstClientY] = useState(0);

  const preventTouch = useCallback(
    (e: TouchEvent) => {
      const contentEl = document.getElementById("content");

      const minValue = 1; // threshold

      const clientX = e.touches[0].clientX - firstClientX;
      const clientY = e.touches[0].clientY - firstClientY;

      if (contentEl) {
        if (Math.abs(clientX) > minValue && clientY >= 0) {
          contentEl.style.overflowY = "hidden";
          contentEl.style.touchAction = "none";
        } else {
          contentEl.style.overflowY = "scroll";
          contentEl.style.touchAction = "auto";
        }
      }
    },

    [firstClientX, firstClientY]
  );

  const touchStart = useCallback((e: TouchEvent) => {
    setFirstClientX(e.touches[0].clientX);
    setFirstClientY(e.touches[0].clientY);
  }, []);

  const allowScroll = useCallback((e: TouchEvent) => {
    const contentEl = document.getElementById("content");
    if (contentEl) {
      contentEl.style.overflowY = "scroll";
      contentEl.style.touchAction = "auto";
    }
  }, []);

  useEffect(() => {
    const sysEl = document.getElementById("synopsys");
    if (sysEl) {
      sysEl.addEventListener("touchstart", touchStart);
      sysEl.addEventListener("touchmove", preventTouch, { passive: false });
      sysEl.addEventListener("touchend", allowScroll, { passive: false });
    }
  }, [touchStart, preventTouch, allowScroll]);

  const sliderSetting = {
    dots: true,
    arrows: false,
    infinite: true,
    autoplay: false,
    autoplaySpeed: 5000,
    pauseOnHover: false,
    speed: window.innerWidth < 768 ? 500 : 1000,
    slidesToShow: 1,
    slidesToScroll: 1,
    touchThreshold: 100,
    swipeToSlide: true,
    swipe: true,
  };

  const posters = useMemo(
    () => [
      {
        id: "poster_2",
        ext: "jpg",
      },
      {
        id: "poster_4",
        ext: "jpg",
      },
      {
        id: "poster_3",
        ext: "jpg",
      },
      {
        id: "poster_1",
        ext: "jpg",
      },
    ],
    []
  );

  return (
    <>
      <Wrapper id="synopsys">
        <Slider {...sliderSetting}>
          {posters.map((poster) => {
            return (
              <ImageWrapper key={poster.id}>
                <img
                  src={`/assets/${poster.id}.${poster.ext}`}
                  alt="poster background"
                />
                <img src={`/assets/${poster.id}.${poster.ext}`} alt="poster" />
              </ImageWrapper>
            );
          })}
        </Slider>
      </Wrapper>
      <Shadow />
    </>
  );
};

export default Synopsys;

const Wrapper = styled.div`
  background: var(--white);
  padding-top: 70px;

  .slick-slide {
    height: calc(var(--app-height, 1vh) - 70px);
  }

  .slick-track {
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    align-items: stretch;
  }

  .slick-dots {
    bottom: 8px;

    li {
      width: 60px;
      height: 4px;
      background: var(--white);
      opacity: 0.5;
      margin: 0;

      &.slick-active {
        opacity: 1;
      }
    }

    button {
      opacity: 0;
      width: 100%;
    }
  }

  @media only screen and (max-width: ${BREAK_POINT.tablet}) {
    padding-top: 40px;

    .slick-slide {
      height: calc(var(--app-height, 1vh) - 40px);
    }

    .slick-dots {
      bottom: 0px;

      li {
        width: 25%;
      }
    }
  }
`;

const ImageWrapper = styled.div`
  position: relative;
  width: 100%;
  height: calc(var(--app-height, 1vh) - 70px);

  img:first-child {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    object-fit: cover;
    z-index: 1;
    opacity: 0.4;
  }
  img:last-child {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    object-fit: contain;
    z-index: 2;
  }

  @media only screen and (max-width: ${BREAK_POINT.tablet}) {
    height: calc(var(--app-height, 1vh) - 40px);
  }
`;

const Shadow = styled.div`
  width: 100%;
  height: 36px;
  background: linear-gradient(
    180deg,
    rgb(194, 194, 194),
    rgb(194, 194, 194, 0.5) 30%,
    transparent
  );

  margin-bottom: 24px;
`;
